import { render, staticRenderFns } from "./ProductPicker.vue?vue&type=template&id=c06afc50&"
import script from "./ProductPicker.vue?vue&type=script&lang=js&"
export * from "./ProductPicker.vue?vue&type=script&lang=js&"
import style0 from "./ProductPicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports